<template>
  <div class="authority-wrap">
    <el-input placeholder="输入关键词进行筛选" v-model="filterText" prefix-icon="el-icon-search"></el-input>

    <div class="tree-box">
      <el-tree
        v-if="isEdit"
        ref="tree"
        v-loading="treeLoading"
        :data="treeData"
        :props="defaultProps"
        show-checkbox
        node-key="id"
        :expand-on-click-node="false"
        :filter-node-method="filterNode"
        :check-strictly="true"
        :render-after-expand="false"
        @check-change="handleCheckChange"
      >
        <span class="custom-tree-node" slot-scope="{ node }">
          <span>{{ node.label }}</span>
        </span>
      </el-tree>

      <el-tree
        v-else
        v-loading="treeLoading"
        ref="activeTree"
        :data="activeTreeData"
        :props="defaultProps"
        node-key="id"
        :expand-on-click-node="false"
        :filter-node-method="filterNode"
      >
        <span class="custom-tree-node" slot-scope="{ node }">
          <span>{{ node.label }}</span>
        </span>
      </el-tree>
    </div>

    <div class="form-buttons">
      <el-button v-auth="'role:menu'" v-if="!isEdit" :disabled="treeLoading" type="primary" @click="openEdit">编辑</el-button>
      <template v-else>
        <el-button @click="getFunctionDataByRole">取消</el-button>
        <el-button :disabled="treeLoading" :loading="saveLoading" type="primary" @click="handleSave">保存</el-button>
      </template>
    </div>
  </div>
</template>

<script>
import { getFunctionData } from '@/api/system';
import { getFunctionDataByRole, saveRolefunc } from '@/api/user';

export default {
  components: {},
  props: {
    roleId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      filterText: '',
      defaultProps: {
        children: 'nodes',
        label: 'text'
      },
      treeLoading: false,
      treeData: [],
      activeTreeData: [],
      saveLoading: false,
      isEdit: false
    };
  },
  watch: {
    roleId(val) {
      if (val) this.getFunctionDataByRole();
    },
    filterText(val) {
      this.$refs.tree.filter(val);
    }
  },
  methods: {
    filterNode(value, data) {
      if (!value) return true;
      return data.text.indexOf(value) !== -1;
    },
    // 获取已有功能模块tree列表
    async getFunctionDataByRole() {
      this.isEdit = false;
      this.treeLoading = true;

      const roleData = await getFunctionDataByRole(this.roleId);
      this.activeTreeData = roleData || [];

      this.treeLoading = false;
    },
    // 打开编辑状态，赋值
    openEdit() {
      this.isEdit = true;

      this.$nextTick(async () => {
        this.treeLoading = true;

        const data = await getFunctionData();
        this.treeData = this.formatTreedata(data) || [];

        const defaultKeys = this.getAllIds(this.activeTreeData || []);
        this.$refs.tree.setCheckedKeys(defaultKeys);
        this.treeLoading = false;
      });
    },
    formatTreedata(data) {
      if (!data) return [];
      // 递归处理 data 数组
      const filterAndRecursivelyProcess = items => {
        return items
          .filter(item => item.deleted !== 1)
          .map(item => {
            if (item.nodes && item.nodes.length > 0) {
              return {
                ...item,
                nodes: filterAndRecursivelyProcess(item.nodes)
              };
            }
            return item;
          });
      };

      return filterAndRecursivelyProcess(data);
    },
    // 父子节点设置不关联后，根据父节点状态改变修改子节点状态
    handleCheckChange(data, checked) {
      const childrens = data.nodes || [];
      childrens.forEach(item => {
        this.$refs.tree.setChecked(item.id, checked);
      });
    },
    getAllIds(data) {
      const keys = [];
      const getKeys = menu => {
        keys.push(menu.id);
        if (menu.nodes && menu.nodes.length > 0) {
          menu.nodes.forEach(getKeys);
        }
      };
      data.forEach(getKeys);
      return keys;
    },
    async handleSave() {
      this.saveLoading = true;

      try {
        const nodeKey = this.$refs.tree.getCheckedKeys();
        const hafCheckedKeys = this.$refs.tree.getHalfCheckedKeys();
        const menu = nodeKey.concat(hafCheckedKeys);
        const rflist = [];
        for (let i = 0; i < menu.length; i++) {
          rflist.push({
            functionId: menu[i],
            roleId: this.roleId
          });
        }
        const params = {
          roleId: this.roleId,
          rflist: JSON.stringify(rflist)
        };

        await saveRolefunc(params);

        this.$message.success('保存成功!');
        this.getFunctionDataByRole();
      } finally {
        this.saveLoading = false;
      }
    }
  },
  created() {},
  mounted() {}
};
</script>

<style lang="scss" scoped>
.authority-wrap {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.tree-box {
  flex: 1 1 auto;
  min-height: 0;
  margin: 14px 0;
}

.form-buttons {
  text-align: right;
}
</style>
